import {
  Box,
  Flex,
  Center,
  IconButton,
  HStack,
} from "@chakra-ui/react";

import { FaDiscord, FaTwitter } from "react-icons/fa";

interface FooterViewProps { }

const FooterView: React.FC<FooterViewProps> = (props) => {
  return (
    <>
      <Box
        mt={8}
        px={4}
      >
        <Box py={4}>
          <Center>
            <Box>Copyright © 2023 Crypto Money Makers</Box>
          </Center>
        </Box>
      </Box>
    </>
  );
};

export default FooterView;
